import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import api from "../lib/api";

// Prompt 20 — needs-card / payment-failed banner (no grace period).
export default function BillingBanner() {
  const [b, setB] = useState(null);
  useEffect(() => {
    api.get("/billing/status").then(({ data }) => setB(data)).catch(() => {});
  }, []);
  if (!b || !["needs_card", "payment_failed"].includes(b.status)) return null;
  const failed = b.status === "payment_failed";
  return (
    <div className={`px-8 py-3 text-sm flex items-center gap-3 border-b ${
           failed ? "bg-red-50 border-red-300 text-red-900" : "bg-amber-50 border-amber-300 text-amber-900"}`}
         data-testid="billing-banner" data-status={b.status}>
      <AlertTriangle size={14} />
      <span className="flex-1">
        {failed
          ? "Payment failed — update your card."
          : "Your free period has ended. Invoices sent to you are held (nothing is lost) until you add a card. Sending invoices is always free."}
      </span>
      <Link to="/settings?tab=billing" className="underline underline-offset-4 font-medium"
            data-testid="billing-banner-link">{failed ? "Update your card" : "Add a card"}</Link>
    </div>
  );
}
